import { VpIcon, VpLink } from '@vtmn-play/react'
import BackButton from '@/src/components/global/back-button/BackButton'
import { StoreDto } from '@/infra/api/generated/model'

type BackToStoreHeaderProps = {
  store: StoreDto
}
const BackToStoreHeader = ({ store }: BackToStoreHeaderProps) => {
  return (
    <div className="flex justify-between items-center">
      <BackButton />
      <VpLink
        variant="tertiary"
        className="truncate max-w-1/2 text-right"
        startSlot={
          <VpIcon data-testid="icon-store" name="store" className="mb-0.5 mr-2 text-primary-gray" />
        }
      >
        {store.id} - {store.name}
      </VpLink>
    </div>
  )
}

export default BackToStoreHeader
